
import React from 'react';
import CountryFilter from './filters/CountryFilter';
import LeagueFilter from './filters/LeagueFilter';
import YearFilter from './filters/YearFilter';
import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

interface FilterSectionProps {
  selectedCountry: string | null;
  selectedLeague: string | null;
  selectedYear: string | null;
  onCountrySelect: (country: string) => void;
  onLeagueSelect: (league: string) => void;
  onYearSelect: (year: string) => void;
  leagues: string[];
  years: string[];
  hideYearSelector?: boolean;
}

const FilterSection: React.FC<FilterSectionProps> = ({
  selectedCountry,
  selectedLeague,
  selectedYear,
  onCountrySelect,
  onLeagueSelect,
  onYearSelect,
  leagues,
  years,
  hideYearSelector = false,
}) => {
  // Fetch countries with correct order from database
  const { data: countryData = [], isLoading } = useQuery({
    queryKey: ['countries'],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('countries')
        .select('name')
        .order('display_order');
      
      if (error) throw error;
      return data || [];
    }
  });

  // Extract just the country names from the data
  const countries = countryData.map(country => country.name);

  return (
    <div className="flex flex-col gap-2 mb-4 justify-center items-center w-full">
      <CountryFilter
        selectedCountry={selectedCountry}
        onCountrySelect={onCountrySelect}
        countries={countries}
      />
      {selectedCountry && (
        <LeagueFilter
          selectedLeague={selectedLeague}
          onLeagueSelect={onLeagueSelect}
          leagues={leagues}
        />
      )}
      {selectedCountry && selectedLeague && !hideYearSelector && (
        <YearFilter
          selectedYear={selectedYear}
          onYearSelect={onYearSelect}
          years={years}
        />
      )}
    </div>
  );
};

export default FilterSection;
